import { render, staticRenderFns } from "./sub-section.vue?vue&type=template&id=a7d37b30"
import script from "./sub-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./sub-section.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports